import React from "react";
import { Controller, useForm } from "react-hook-form";
import AccountSelect from "../AccountSelect";
import useTranslation from "../../../../../../shared/hooks/useTranslation";
import { Account } from "../../../../../../services/management/account/types";
import { UnitStatusEnum } from "../../../../../../services/management/units/api";
import ToggleSwitch from "../../../../../../shared/components/redesigned/ToggleSwitch";

export interface FormValues {
    account: Account | null;
    priority: boolean;
    status: UnitStatusEnum | null;
}

export default function UnitSearchForm({
    context,
}: {
    context: ReturnType<typeof useForm<FormValues>>;
}) {
    const { t } = useTranslation();
    const { control, register } = context;

    return (
        <form
            onSubmit={(e) => e.preventDefault()}
            className="@container flex w-full flex-col gap-3"
        >
            <div className="flex min-w-0 flex-col gap-3 @sm:flex-row @sm:items-center @sm:gap-4">
                <div className="min-w-0 flex-1">
                    <Controller
                        render={({ field }) => (
                            <AccountSelect
                                placeholder={t("unit_search_form.fields.account.placeholder")}
                                {...field}
                            />
                        )}
                        name="account"
                        control={control}
                    />
                </div>
                <ToggleSwitch
                    {...register("priority")}
                    label={t("unit_search_form.fields.priority.label")}
                    className="shrink-0"
                />
            </div>
            <div>
                <label htmlFor="status" className="mb-1 block text-xs font-medium text-ink-muted">
                    {t("unit_search_form.fields.status.label")}
                </label>
                <Controller
                    name="status"
                    control={control}
                    render={({ field: { onChange, value, ...rest } }) => (
                        <select
                            {...rest}
                            id="status"
                            value={value ?? ""}
                            onChange={(e) => onChange(e.target.value || null)}
                            className="w-full rounded-md border border-border bg-surface px-3 py-2 text-sm text-ink focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent/40"
                        >
                            <option value=""></option>
                            {Object.values(UnitStatusEnum).map((status) => (
                                <option key={status} value={status}>
                                    {t(`attributes.data_entering.units.statuses.${status}`)}
                                </option>
                            ))}
                        </select>
                    )}
                />
            </div>
        </form>
    );
}
